// FIXME: Fix import/named export issue for firebase
/* eslint-disable import/named */
import {
	OAuthProvider,
	GoogleAuthProvider,
	FacebookAuthProvider,
	TwitterAuthProvider,
	signInWithPopup,
	linkWithCredential,
	fetchSignInMethodsForEmail,
	updateProfile
} from 'firebase/auth'

/**
 * @param {*} firebaseAuth firebase auth instance
 * @param {string} provider 'google' or 'facebook' or 'twitter' or 'apple'
 * @param {Function} loginUserCallback callback to be called when user retrieved from Firebase
 */
async function signInWithProvider (firebaseAuth, provider, loginUserCallback) {
	if (!firebaseAuth) {
		throw new Error('Firebase app has not been initialized')
	}

	async function handleUserWithExistingCredential (email, credential) {
		const [signInMethod] = await fetchSignInMethodsForEmail(firebaseAuth, email)

		if (!signInMethod) {
			throw new Error('Account is linked to an unsupported provider')
		}

		const linkedProvider = getAuthProvider(signInMethod)

		linkedProvider.setCustomParameters({ login_hint: email })

		const { user } = await signInWithPopup(firebaseAuth, linkedProvider)

		await linkWithCredential(user, credential)

		await loginUserCallback(user)
	}

	const authProvider = getAuthProvider(provider)

	try {
		const { user } = await signInWithPopup(firebaseAuth, authProvider)

		if (provider === 'apple') {
			const currentProviderData = user?.providerData?.find(el => el.providerId === 'apple.com')
			const displayName = currentProviderData?.displayName

			displayName && updateProfile(user, { displayName })
		}

		await loginUserCallback(user)
	} catch (error) {
		switch (error.code) {
				case 'auth/popup-closed-by-user':
				case 'auth/cancelled-popup-request':
					throw error
				case 'auth/account-exists-with-different-credential': {
					const credential = OAuthProvider.credentialFromError(error)

					await handleUserWithExistingCredential(error.customData.email, credential)
					break
				}
				default:
					throw error
		}
	}
}

function getAuthProvider (providerId) {
	switch (providerId) {
			case 'google':
			case GoogleAuthProvider.PROVIDER_ID:
				return new GoogleAuthProvider().setCustomParameters({ prompt: 'select_account' })
			case 'facebook':
			case FacebookAuthProvider.PROVIDER_ID:
				return new FacebookAuthProvider()
			case 'twitter':
			case TwitterAuthProvider.PROVIDER_ID:
				return new TwitterAuthProvider()
			case 'apple':
			case 'apple.com':
				return new OAuthProvider('apple.com')
			default:
				throw new Error(`Unknown provider: ${providerId}`)
	}
}

export default {
	signInWithProvider
}
